<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_notification_certificate</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search :title="pageTitle"></title-and-search>
          <button class="btn btn-primary btn-sm" style="min-width:50px;width: 10%" @click="backToList" >＜　戻る</button>
          <br>
          <br>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 530px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
             件数<input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <device-embedded-information-bach-edit-modal tag="showDeviceEmbeddedInformationBachEditModal" />
            <file-download-modal tag="runDeviceEmbeddedInformationDownloadModal" @close="onCloseExportFile"/>
          <!-- <button :disabled="selected_row == -1" class="btn btn-danger btn-xs" style="float: right;margin-left: 10px;" @click="onDelete">削除</button>
          <button :disabled="selected_row == -1" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;"  @click="onEdit">編集</button> -->
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import moment from "moment";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_software';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:notification_certificate');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import fileDownloadModal from '@/components/modals/file-download-modal';
import { bus } from '@/libs/bus';
import deviceEmbeddedInformationBachEditModal from '@/components/modals/device-embedded-information-bach-edit-modal';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'device-embedded-information-bach-edit-modal' : deviceEmbeddedInformationBachEditModal,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"notification_certificate",
      page_acl: acl.generic,
      detail_page:"page_0040_certificate_software_detail",
      execute_filter_on_back:true,
      link_to_open:"#",
      load_only_with_filter:true,
      page_title:"~"
    };
  },
  computed: {
    pageTitle:{
      get(){
        return this.page_title;
      },
      set(v){
        this.page_title = v;
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.certificate_software_number, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.effective_number, {}),
        utils.extend(fields.remaining_number, {}),
        utils.extend(fields.expiration_date, {type:filed_types.DATE_PICKER}),
        utils.extend(fields.maintenance_deadline, {type:filed_types.DATE_PICKER}),
      ];
    },
    tabFieldList2() {
      return [
            utils.extend(fields.approval_status, {}),
            utils.extend(fields.maker, {}),
            utils.extend(fields.certificate_software_number, {tab_label:"証書管理番号"}),
            utils.extend(fields.software_name, {}),
            utils.extend(fields.license, {}),
            utils.extend(fields.expiration_date, {}),
            utils.extend(fields.maintenance_deadline, {}),
            utils.extend(fields.deadline_check, {
              cellRenderer:(params) =>{
                if(params.value < 0){
                  return "<span style='color:red';>"+params.value+"</span>" ;
                }else{
                  return params.value;
                }
              }
            })
          ];
    }
  },
  methods: {
    createColumnDefs(field_list_name="tabFieldList") {
      return this.commonCreateColumnDefs({show_details:false,show_checkbox:false,field_list_name})
    },
    backToList(){
      return this.$router.push( "/menu/");
    },
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbeddedInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:"/certificate_information/export_data/"
      });
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    bachEdit(){
      var p_id = uuid.v4()
      var obj = {arr:this.selectedRowArr.map(m=>{return m.seq_id})}
      Vue.localStorage.set("bulk_edit_" + p_id, JSON.stringify(obj))
      return this.$router.push("/certificate_information/bulk_edit/" + p_id);
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    switch (this.$route.meta.mode) {
      case "certificate_that_expires_in_3_months":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"))
        this.api_request_options = {filter_mode:"all"};
        this.pageTitle ="3カ月以内に有効期限が切れるライセンス"
        bus.$emit("onOpenPageFilter",{field:"expiration_date",val:moment(new Date()).format("YYYY/MM/DD")})
        bus.$emit("onOpenPageFilter2",{
          field:"expiration_date",
          val:moment(new Date()).add(90,"days").format("YYYY/MM/DD"),
          cb:()=>{
            bus.$emit("onOpenPageFilterJoin1","BETWEEN")
        }})
        break;
      case "certificate_expired_license":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList"))
        this.api_request_options = {filter_mode:"all"};
        this.pageTitle ="有効期限切れライセンス"
        bus.$emit("onOpenPageFilter",{field:"expiration_date",val:moment("1999/01/01").format("YYYY/MM/DD")})
        bus.$emit("onOpenPageFilter2",{
          field:"expiration_date",
          val:moment(new Date()).subtract(1,"day").format("YYYY/MM/DD"),
          cb:()=>{
            bus.$emit("onOpenPageFilterJoin1","BETWEEN")
          }
        })
        break;
      case "surplus_license_that_expires_in_3_months":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"))
        this.api_request_options = {filter_mode:"余剰"};
        this.pageTitle ="3カ月以内に有効期限が切れる余剰ライセンス"
        bus.$emit("onOpenPageFilter",{field:"expiration_date",val:moment(new Date()).format("YYYY/MM/DD")})
        bus.$emit("onOpenPageFilter2",{
          field:"expiration_date",
          val:moment(new Date()).add(90,"days").format("YYYY/MM/DD"),
          cb:()=>{
            bus.$emit("onOpenPageFilterJoin1","BETWEEN")
        }})
        break;
      case "surplus_expired_license":
        this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"))
        this.api_request_options = {filter_mode:"余剰"};
        this.pageTitle ="有効期限切れ余剰ライセンス"
        bus.$emit("onOpenPageFilter",{field:"expiration_date",val:moment("1999/01/01").format("YYYY/MM/DD")})
        bus.$emit("onOpenPageFilter2",{
          field:"expiration_date",
          val:moment(new Date()).subtract(1,"day").format("YYYY/MM/DD"),
          cb:()=>{
            bus.$emit("onOpenPageFilterJoin1","BETWEEN")
          }
        })
        break;
      default:
        break;
    }
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
    bus.$emit("onSearchClear",{})
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.api_request_options = {filter_mode:"all"};
    this.initDatasource({load_only_with_filter:true});
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_notification_certificate.vue?c7b6d7fa